// CallToAction.js
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * A call-to-action prompting homeowners to get a free estimate or consultation.
 */
const CallToAction = () => {
  return (
    <Box
      component="section"
      aria-labelledby="residential-cta"
      sx={{
        py: { xs: 4, md: 6 },
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
        textAlign: 'center',
      }}
    >
      <Container>
        <Typography
          id="residential-cta"
          variant="h4"
          gutterBottom
          sx={{ fontWeight: 700 }}
        >
          Ready to Transform Your Yard?
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, maxWidth: 600, mx: 'auto' }}>
          Contact us for a free estimate and let our experts bring your
          residential landscaping vision to life.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href="/contact"
        >
          Get a Free Estimate
        </Button>
      </Container>
    </Box>
  );
};

export default CallToAction;
